import { useMemo } from 'react';
import { useTransitionConfig } from '../useTransitionConfig';
import { px2px, px2vw } from './convertors';
export function useLengthUnitConvertor() {
    var _a = useTransitionConfig(), lengthUnit = _a.lengthUnit, viewportWidth = _a.viewportWidth;
    var convertor = useMemo(function () {
        if (lengthUnit === 'vw') {
            return function (value) { return px2vw(value, { viewportWidth: viewportWidth }); };
        }
        return px2px;
    }, [lengthUnit, viewportWidth]);
    return convertor;
}
